import React from "react"
import styled from "styled-components"
import { Modal, Dropdown } from "buoy-core"
import { fontWeight, fontSize } from "buoy-theme"

const DELETION_REASONS = [
  "I don't find Buoy useful",
  "I don't understand how to use Buoy",
  "I have a privacy concern",
  "Other"
]

const Label = styled.label`
  ${fontSize("label")};
  font-weight: ${fontWeight.medium};
  letter-spacing: 0.9px;
  color: #646464;
  text-transform: uppercase;
`

const FormContainer = styled.div`
  margin: 10px 0;
`

const ReasonForm = ({ onSelect, onSubmit, reason }) => {

  const options = DELETION_REASONS.map(reason => { return { value: reason, text: reason }})

  return (
    <FormContainer>
      <Label>Reason for deleting</Label>
      <Dropdown 
        placeholder="Select One"
        value={reason}
        options={options}
        onChange={onSelect}
      />
    </FormContainer>
  )
}


class DeleteAccountModal extends React.Component {

  state = {
    reason: null
  }

  onSelectReason = reason => {
    this.setState({reason: reason})
  }

  confirmDeletion = () => {
    if (this.state.reason) {
      this.props.deleteAccount(this.state.reason)
    }
  }

  render() {

    return (
      <Modal
        heading="Are you sure you want to delete your account?"
        message="Deleting your account will permanently remove your 
                 saved information and visit history."
        submitText="Delete Account"
        submitClick={this.confirmDeletion}
        submitEnabled={this.state.reason !== null}
        cancelClick={this.props.closeModal}
        >
        
        <ReasonForm
          reason={this.state.reason}
          onSelect={this.onSelectReason}
          onSubmit={this.confirmDeletion}
        />

      </Modal>
    )
  }

}

export default DeleteAccountModal


// WEBPACK FOOTER //
// ./assets/account/components/DeleteAccountModal.js